import { useEffect, useState } from 'react';
import { paddClient as padd } from '@plangrid-private/web-api-clients';

const paddClient = {
  fetchSourceTemplate: async (projectId) => {
    const result = await padd.getSourceTemplate(projectId);
    return result;
  },
};

export const useSourceTemplate = (projectId) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [sourceTemplateData, setSourceTemplateData] = useState(undefined);

  useEffect(() => {
    if (projectId) {
      setLoading(true);
      paddClient
        .fetchSourceTemplate(projectId)
        .then((sourceTemplate) => setSourceTemplateData(sourceTemplate))
        .catch(() => setError(true))
        .finally(() => setLoading(false));
    }
  }, [projectId]);

  return {
    loading,
    error,
    sourceTemplateData,
  };
};
